import axios from 'axios';

// Determine if running in production (usually via build process)
const isProduction = process.env.NODE_ENV === 'production';

// Define the base URL based on environment
// For Development: Use the REACT_APP_ variable from .env or a hardcoded fallback
// For Production: Use a relative path '/api' assuming frontend is served by the same server as the API
const baseURL = isProduction
  ? '/api'
  : process.env.REACT_APP_API_URL_DEVELOPMENT || 'http://localhost:8000/api'; // Ensure fallback includes /api

// Log the determined baseURL ONLY during development for easier debugging
if (!isProduction) {
  console.log(`[API Client] Development Mode. Using Base URL: ${baseURL}`);
  if (!process.env.REACT_APP_API_URL_DEVELOPMENT) {
    console.warn(`[API Client] REACT_APP_API_URL_DEVELOPMENT not found in .env file. Using fallback: ${baseURL}`);
  }
}

export const apiClient = axios.create({
  baseURL: baseURL, // Ensure this baseURL is correctly set
  headers: {
    'Content-Type': 'application/json',
  },
  transitional: {
    clarifyTimeoutError: true,
  },
});

// Request interceptor (adds Authorization header)
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Log the actual request URL being hit during development (optional)
  // if (!isProduction) {
  //   console.log(`[API Request] ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
  // }
  return config;
});

// Response interceptor (for error handling/logging)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.config?.url, error.message, error.response?.status, error.response?.data);
    // Trigger global notification for errors if desired
    return Promise.reject(error);
  }
);

export default apiClient;